import {Component, ViewChild} from '@angular/core';
import {Events, NavController, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {CacheService} from "ionic-cache"
import {AppRouter} from "./app.router";
import {
  CheckUtils,
  CustomLanguageLoader,
  LanguageProvider,
  LoggerStorage,
  OrganizationDetailsProvider,
  OrganizationProvider
} from "od-ts";
//LanguageProvider,
import {ENV} from '@env';
import {TranslateService} from "@ngx-translate/core";
import {AppVoData} from "@app/app-vo-data";
import {UserConverter} from "@utils/converter/user-converter";

@Component({
  templateUrl: 'app.html'
})

export class MyApp {

  @ViewChild('content') nav: NavController;

  constructor(private _platform: Platform, private _statusBar: StatusBar, private _splashScreen: SplashScreen, private _router: AppRouter,
              private _cache: CacheService, private _events: Events, private _languageProvider: LanguageProvider,
              private orgProvider: OrganizationProvider, private _loggerStorage: LoggerStorage,
              private _organizationDetailsProvider: OrganizationDetailsProvider,
              private  _customLanguageLoader: CustomLanguageLoader, private _translate: TranslateService) {
    this._translate.currentLoader = this._customLanguageLoader;
    this.bind();
  }

  private receiveMessage(evt) {
      if (evt.data.hasOwnProperty('embedMainApp') && evt.data.embedMainApp) {
        document.body.classList.add("embed-main-app");
      } else if (evt.data.hasOwnProperty('allowApps') && evt.data.allowApps) {
        let result:AppVoData[] = [];
        evt.data.allowApps.split(",").forEach((value)=>{
          result.push(new AppVoData(Number(value.substr(2)),value.substr(0,2)));
        });
        document['allowApps'] = result;
      }
  }

  private bind() {
    window.addEventListener("message", this.receiveMessage, false);
    this._platform.ready().then(() => this.onReady());
  }

  private onReady() {
    this.app();
    this.logger();
    this.cache();
    this.router();
  }

  private app() {
    UserConverter.organizationDetailsProvider=this._organizationDetailsProvider;

    if (CheckUtils.isApp(this._platform)) {
      this._statusBar.styleDefault();
      this._splashScreen.hide();
      this.orgProvider.setUri(ENV.uri);
      this._router.setRoot("CreationFormPage");
    }
  }

  private cache() {
    this._cache.enableCache(true);
    this._cache.setDefaultTTL(ENV.cacheDefaultTTL);
    this._cache.setOfflineInvalidate(false);
  }

  private router() {
    this._router.init(this.nav);
  }

  private logger() {
    this._loggerStorage.createLocalDb();
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts